import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialGroupLaboratoryContractState: Dtos.TrialGroupLaboratoryContract & IRegistrationFormState = {
    id: null,
    trialGroupLaboratoryId: null,
    trialGroupLaboratory: null,
    name: null,
    location : null,
    dateSentToSite: null,
    dateConfirmedBySite: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialGroupLaboratoryContractReduxFormState {
    id: IFieldState<number>,
    trialGroupLaboratoryId: IFieldState<number>,
    trialGroupLaboratory: IFieldState<Dtos.TrialGroupLaboratory>,
    name: IFieldState<string>,
    location : IFieldState<string>,
    dateSentToSite: IFieldState<string>,
    dateConfirmedBySite: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
